import { requestCreate, requestDelete, requestUpdate, sendRequest } from "../api"
import { ADD_IN_LIST, REMOVE_IN_LIST, RESET_FORM, RESET_STATE, SET_FORM, SET_LIST, UPDATE_IN_LIST } from "../constant-types"
import { getField, updateField } from 'vuex-map-fields'

const getDefaultState = () => {
    return {
        list : {
            list : [],
            sum_balance : 0
        },
        list_loading: false,
        form : getDefaultFormState(),
    }
}

const getDefaultFormState = () => {
    return {
        id : '',
        user_id : '',
        category_id : '',
        name : '',
        init_balance : 0,
        balance : 0,
        account_sync_id : ''
    }
}

export default ({
    namespaced: true, //
    // variable
    state: getDefaultState(),
    // must syncronous
    mutations: {
        [RESET_STATE](state) {
            // Merge rather than replace so we don't lose observers
            // https://github.com/vuejs/vuex/issues/1118
            Object.assign(state, getDefaultState())
        },
        [ADD_IN_LIST](state, userCash) {
            state.list.list.unshift(userCash)
        },
        [SET_LIST](state, payload) {
            state.list = payload
        },
        [SET_FORM](state, payload) {
            Object.assign(state.form, payload)
        },
        [RESET_FORM](state) {
            state.form = getDefaultFormState()
        },
        [REMOVE_IN_LIST](state, userCash) {
            let idx = state.list.list.findIndex(l => l.id == userCash.id)
            state.list.list.splice(idx, 1)
        },
        [UPDATE_IN_LIST](state, userCash) {
            let idx = state.list.list.findIndex(l => l.id == userCash.id)
            Object.assign(state.list.list[idx], userCash)
        },
        updateField

    },
    // can async
    actions: {
        loadList({commit}) {
            commit('updateField', { path: 'list_loading', value  : true })
            sendRequest('user-cash', {}, 'get', (success) => {
                commit(SET_LIST, success)
                commit('updateField', { path: 'list_loading', value  : false })
            }, () => {}, ()=>{}, true, false)
        },
        requestCreateUserCash({commit, state}) {
            requestCreate('user-cash', state.form, commit)
        },
        requestUpdateUserCash({commit, state}) {
            requestUpdate('user-cash', state.form, commit)
        },
        requestDeleteUserCash({commit}, userCash) {
            requestDelete(`user-cash/${userCash.id}`, {}, commit, userCash.name)
        }
    },
    // call variable with custom display
    getters: {
        listSorted : state => ( sortMode = 'asc', filterText) => {
            let r = state.list.list.filter(l => l.name.toLowerCase().match(filterText))
            return _.orderBy(r, ['balance'], [sortMode])
        },
        getUserCashBalance : state => userCashId => {
            let r = state.list.list.find(l => l.id == userCashId)
            return r ? r.balance : 0
        },
        getField
    }
})
